import { module } from 'modujs';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { isMobile } from 'mobile-device-detect';
import Swiper from "swiper";

export default class extends module {
    constructor(m) {
        super(m);

    }
    init() {
        this.scroll = this.modules.Scroll.main.lenis;
        this.movable = this.$( 'movable' )[0];
        if( ! isMobile ) this.horizontalScroll();
        else {
            this.movable.classList.add( 'swiper-wrapper' );
            this.swiper = new Swiper(this.$( 'swiper' )[0] , { slidesPerView: 'auto' });
        }

    }
    horizontalScroll(){
        gsap.to( this.movable , {
            x: () => -this.horizontalMove(),
            ease: "none",
            scrollTrigger: {
                scroller: this.modules.Scroll.main.el,
                trigger: this.$( 'trigger' )[0],
                start: () => {
                    return  "top center+=" + ( document.querySelector( 'header' ).clientHeight/2  )
                },
                pin: this.$( 'pin' )[0],
                end: () => this.horizontalMove() * Math.max( 2, 2 * 1440 / window.innerWidth ) ,
                scrub: true,
                invalidateOnRefresh: true,
                anticipatePin: 1,
                /*markers: true,*/
            }
        });
    }
    horizontalMove(){
        return this.movable.offsetWidth - this.movable.parentNode.offsetWidth
    }


    destroy(){
        window.removeEventListener( 'resize', this.onResizeBind );
    }
}
